import { clsx, type ClassValue } from 'clsx'

/**
 * Concatène des classes CSS en ignorant `false`, `null` et `undefined`.
 *
 * ⚠️ Ce n'est PAS le `cn()` de shadcn : il n'y a pas de `twMerge` ici, parce qu'il n'y a
 * pas de Tailwind (cf. ARCHITECTURE.md D20). Les classes viennent de modules CSS, donc
 * elles sont déjà uniques et scopées — il n'y a aucun conflit d'utilities à départager.
 */
export function cn(...classes: ClassValue[]): string {
  return clsx(classes)
}
